// extracted by mini-css-extract-plugin
var _1 = "ChapterPathBackgroundLandscape__chapterPathBackgroundLandscape--EaNDl";
var _2 = "ChapterPathBackgroundLandscape__img--bmxdV ChapterPathStyles__antiSeams--XNFsH ChapterPathStyles__antiLag--A6PV1";
export { _1 as "chapterPathBackgroundLandscape", _2 as "img" }
